import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
// import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../../hooks/usePostRequest";
import DynamicPagination from "../../../components/DynamicPagination ";
import { API_ENDPOINTS } from "../../../constant/_constant";
import {
  IconBox,
} from "@tabler/icons-react";

function ProductSelectModal({ show, onHide, selectedProducts = [], onApply }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchDebounce, setSearchDebounce] = useState({
    searchSku: "",
    vendor_id: "",
    type: "",
  });
  const [localSelected, setLocalSelected] = useState([]);

  const { data: vendorlist, postData: fetchVendorList } = usePostRequest(
    API_ENDPOINTS.GET_VENDORS
  );

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION
  );

  useEffect(() => {
    if (show) {
      fetchVendorList({ page: 1, limit: 500, is_relevent: true });
      setLocalSelected(selectedProducts);
    }
  }, [show]);

  useEffect(() => {
    if (!show) return;
    fetchProductSearch({
      page,
      limit,
      module_type: "RFQ",
      vendor_id: searchDebounce?.vendor_id || null,
      type: searchDebounce?.type || undefined,
      search: searchDebounce?.searchSku || null,
    });
  }, [page, limit, searchDebounce, show]);

  const isSelected = (p) => localSelected.some((x) => x.sku_id === p.sku_id);

  const toggleSelect = (product) => {
    setLocalSelected((prev) =>
      isSelected(product)
        ? prev.filter((p) => p.sku_id !== product.sku_id)
        : [
          ...prev,
          {
            sku_id: product.sku_id,
            sku_display_name: product.sku_display_name,
            name: product.name,
          },
        ]
    );
  };

  const removeChip = (sku_id) =>
    setLocalSelected((prev) => prev.filter((p) => p.sku_id !== sku_id));

  const handleApply = () => {
    onApply(localSelected);
    onHide();
  };

  const handleClearAll = () => setLocalSelected([]);

  const handleClose = () => {
    setSearchDebounce({ searchSku: "", vendor_id: "", type: "" });
    setPage(1);
    onHide();
  };

  return (
    <Modal
      scrollable
      show={show}
      onHide={handleClose}
      className="skusearch"
      dialogClassName="modal-90vw"
    >
      <Modal.Header closeButton>


        <div className="w-100">
          <div className="d-flex align-items-center gap-2">
            <div className="gap-2 align-items-center modal-header">
              <span className="avatar bg-indigo-lt rounded-circle">
                <IconBox />
              </span>
              <div><div class="modal-title h4">Add products to filter </div><div class="card-subtitle h6">Pick one or more from product library</div></div>

            </div>

          </div>
          {/* <h5 className="mb-3">Add products to filter </h5> */}
          <Row>
            <Col className="mb-2">
              <Form.Control
                type="text"
                placeholder="Search SKU / Name"
                autoComplete="off"
                value={searchDebounce.searchSku}
                onChange={(e) => {
                  setSearchDebounce((p) => ({
                    ...p,
                    searchSku: e.target.value,
                  }));
                  setPage(1);
                }}
              />
            </Col>
            <Col className="mb-2">
              <Form.Select
                value={searchDebounce.vendor_id}
                onChange={(e) => {
                  setSearchDebounce((p) => ({
                    ...p,
                    vendor_id: e.target.value,
                  }));
                  setPage(1);
                }}
              >
                <option value="">All Vendors</option>
                {vendorlist?.data?.map((v) => (
                  <option
                    key={v.VendorContact?.vendor_id}
                    value={v.VendorContact?.vendor_id ?? 0}
                  >
                    {v.display_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col className="mb-2">
              <Form.Select
                value={searchDebounce.type}
                onChange={(e) => {
                  setSearchDebounce((p) => ({ ...p, type: e.target.value }));
                  setPage(1);
                }}
              >
                <option value="">All Types</option>
                <option value="inventory">Inventory</option>
                <option value="non-inventory">Non-Inventory</option>
                <option value="kit">Kit</option>
              </Form.Select>
            </Col>
          </Row>
        </div>
      </Modal.Header>

      <Modal.Body style={{ minHeight: "60vh" }}>
        {localSelected.length > 0 && (
          <div className="mb-3 p-2 border rounded bg-light">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <strong className="small">
                Selected ({localSelected.length})
              </strong>
              <Button
                variant="link"
                size="sm"
                className="text-decoration-none p-0"
                onClick={handleClearAll}
              >
                Clear all
              </Button>
            </div>
            <div className="d-flex flex-wrap gap-2">
              {localSelected.map((p) => (
                <span
                  key={p.sku_id}
                  className="badge bg-white text-dark border d-flex align-items-center gap-1"
                  style={{ fontSize: 12 }}
                >
                  {p.sku_display_name}
                  <span
                    role="button"
                    onClick={() => removeChip(p.sku_id)}
                    style={{ cursor: "pointer" }}
                  >
                    ×
                  </span>
                </span>
              ))}
            </div>
          </div>
        )}

        <div className="table-responsive">
          <Table hover>
            <thead>
              <tr>
                <th style={{ width: 40 }}></th>
                <th>VENDOR</th>
                <th>SKU</th>
                <th>PRODUCT NAME</th>
                <th>TYPE</th>
                <th>DESCRIPTION</th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.map((product, idx) => (
                <tr
                  key={idx}
                  onClick={() => toggleSelect(product)}
                  style={{ cursor: "pointer" }}
                  className={isSelected(product) ? "table-active" : ""}
                >
                  <td onClick={(e) => e.stopPropagation()}>
                    <Form.Check
                      type="checkbox"
                      checked={isSelected(product)}
                      onChange={() => toggleSelect(product)}
                    />
                  </td>
                  <td>{product?.Vendor?.display_name}</td>
                  <td className="text-orange">{product?.sku_display_name}</td>
                  <td className="text-orange">{product?.name}</td>
                  <td>
                    {{
                      kit: "Kit",
                      "non-inventory": "Non-Inventory",
                      inventory: "Inventory",
                    }[product?.type] || ""}
                    {product?.kit_type ? ` (${product.kit_type})` : ""}
                  </td>
                  <td>
                    {product?.description_sales?.length > 100
                      ? product.description_sales.slice(0, 100) + "..."
                      : product?.description_sales}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {data?.data?.length > 0 ? (
          <DynamicPagination
            totalPages={data?.pagination?.totalPages}
            currentPage={page}
            onPageChange={setPage}
            limitPerPage={limit}
            onLimitChange={setLimit}
          />
        ) : (
          <p className="text-center mt-2">No matching records found.</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleApply}>
          Add Selected ({localSelected.length})
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ProductSelectModal;